import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[70vh] w-full flex-col items-center justify-center px-4 py-24 text-center">
      <p className="font-heading text-7xl font-700 text-primary-200 md:text-9xl">404</p>
      <h1 className="mt-4 text-xl font-700 text-foreground-950 md:text-2xl">页面走丢了</h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你访问的页面不存在或已被移除：<span className="font-mono text-foreground-700">{location.pathname}</span>
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-500 text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-home-4-line text-lg" aria-hidden="true"></i>
          返回首页
        </Link>
        <Link
          to="/category/电影"
          className="rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100 whitespace-nowrap"
        >
          浏览影视
        </Link>
      </div>
    </div>
  );
}